






















import { Vue } from 'vue-property-decorator';
import { UserService } from './services/UserService';
import AxiosConfiguration from '@/classes/AxiosConfiguration';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import ExpiryModal from '@/components/shared/ExpiryModal.vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import { mapGetters, mapActions } from 'vuex';
import { MStoreConstants, InformationModalSettings } from '@/types';
import axios from 'axios';
import moment from 'moment';
import { MStorePopup, Feedback } from '@/components/shared';
import { ModalHelpers, confirmationHelper } from '@/mixins';
import { LocalStorage, Fullscreen } from '@/utils';
moment.locale('en-gb');

const defaultlayout = 'Default';
const localStorageKeys = MStoreConstants.LocalStorageKeys;
export default Vue.extend({
  mixins: [ModalHelpers, confirmationHelper],
  data(this: any) {
    return {
      isAppIdleModalShown: false,
      waitForPostSignInIdleTime: true,
      nowIntervalId: 0,
      now: moment(),
      keepAliveInclude: '',
      appIdleTimeout: moment(),
      localStorageKeys: MStoreConstants.LocalStorageKeys,
      refreshing: false,
      registration: null,
      isSigningOut: false
    };
  },
  computed: {
    ...mapGetters('oidcStore', ['oidcIsAuthenticated', 'oidcAccessToken']),
    ...mapGetters('userStore', ['postSignInIdleTime']),
    ...mapGetters('applicationDirtyStore', ['isApplicationDirty', 'isApplicationDirtyOnAnotherTab', 'isApplicationDirtyOnModal', 'showApplicationDirtyModal', 'applicationDirtyRouteNavigatedTo']),
    ...mapGetters('workflowQueueStore', ['getLastSelectedWorkflowQueue']),
    hasAccess(this: any) {
      return this.oidcIsAuthenticated || this.$route.meta.isPublic;
    },
    layout(this: any) {
      return (this.$route.meta.layout || defaultlayout) + 'Layout';
    },
    showAppIdleModal(this: any) {
      return this.isAppIdleModalShown && !this.waitForPostSignInIdleTime;
    },
    expirySecondsLeft(this: any) {
      const expiryDate = moment(this.appIdleTimeout);
      const diff = expiryDate.diff(this.now);
      return Math.ceil(diff / 1000);
    },
    lastSelectedQueueId(this: any) {
      return this.getLastSelectedWorkflowQueue;
    },
    isActiveTab() {
      return !document.hidden;
    }
  },
  methods: {
    ...mapActions('oidcStore', ['signOutOidc', 'removeOidcUser']),
    ...mapActions('userStore', ['clearPostSignInIdleTime', 'currentUserAuthenticated']),
    ...mapActions('workflowQueueStore', ['setLastSelectedWorkflowQueue']),
    ...mapActions('applicationDirtyStore', ['setShowApplicationDirtyModal', 'setApplicationDirty', 'setApplicationDirtyOnAnotherTab', 'setApplicationDirtyOnModal']),
    ...mapActions('userPreferencesStore', ['updateVuexPersistedState']),
    setNowToNow() {
      this.now = moment();
    },
    signOut(this: any) {
      this.setApplicationDirty(false);
      UserService.disableWindowsAutoLogInForCurrentUserAsync().then(() => {
        this.signOutOidc();
      });
    },
    beforeUnloadApplication(this: any, event: any) {
      if ((this.isApplicationDirty || this.isApplicationDirtyOnModal) && !this.isAppIdle) {
        // event.preventDefault(); is the standard way to cancel the event and is supported by all modern browsers. Older versions of chrome require event.returnValue = ''; to cancel an event
        event.preventDefault();
        event.returnValue = '';
      } else {
        LocalStorage.remove(localStorageKeys.IsApplicationDirty);
      }
    },
    extendSession(this: any, event: any) {
      if (!document.hidden && this.isAppIdle && !Fullscreen.isFullscreen()) {
        this.isAppIdleModalShown = false;
        return;
      }
      this.$store.commit('idleStore/IDLE_CHANGED', false);
      this.isAppIdleModalShown = false;
      if (!document.hidden) {
        this.notifyOtherTabs(localStorageKeys.IsAppIdleExtended, event);
      }
    },
    showIdleTimeOut(this: any, event: any) {
      if (!document.hidden && (!this.isAppIdle || Fullscreen.isFullscreen())) {
        return this.extendSession();
      }
      if (!this.isAppIdleModalShown) {
        this.isAppIdleModalShown = true;
        this.appIdleTimeout = moment().add(60, 'seconds');
        this.notifyOtherTabs(MStoreConstants.LocalStorageKeys.IsAppIdleOnAnotherTab, event);
      }
    },
    notifyOtherTabs(key: string, event: any) {
      if (event !== true) {
        LocalStorage.emit(key, true);
      }
    },
    manageLastSelectedWorkflowQueue(this: any, lastSelectedWorkflowQueueId: number) {
      if (lastSelectedWorkflowQueueId !== this.lastSelectedQueueId) {
        this.setLastSelectedWorkflowQueue(lastSelectedWorkflowQueueId);
      }
    },
    async confirmDiscardChangesOnApplicationDirty(this: any, callback: () => any) {
      try {
        const hasUnsavedChangesToKeep: boolean = await this.hasUnsavedChangesToKeepAsync(this.$bvModal, true);
        if (!hasUnsavedChangesToKeep) {
          this.setApplicationDirty(false);
          this.setApplicationDirtyOnModal(false);
          callback();
        }
        this.setShowApplicationDirtyModal(false);
      } catch (error) {
        this.$log(error);
      }
    },
    async onApplicationUpdateAvailable(this: any, event: any) {
      this.registration = event.detail;
      const informationModalSettings: InformationModalSettings = {
        title: 'Software Update',
        isHtml: true
      };
      const message = `An updated version of ${MStoreConstants.AppName} is available, click OK to update.<br/>
      <b>(This page will be refreshed and any changes will be lost.)</b>`;
      await this.showInformationModalAsync(this.$bvModal, message, informationModalSettings);
      if (!this.registration || !this.registration.waiting) {
        return;
      }

      (await self.caches.keys()).forEach(async (cacheName) => {
        await self.caches.delete(cacheName);
      });

      this.registration.waiting.postMessage('SKIP_WAITING');
    },
    refreshApp(this: any) {
      if (this.refreshing) {
        return;
      }

      this.refreshing = true;
      this.updateVuexPersistedState();
      window.location.reload();
    },
    signOutFromAnotherTab(this: any) {
      this.setApplicationDirty(false);
      if (!this.isSigningOut && this.oidcIsAuthenticated) {
        this.isSigningOut = true;
        this.signOut();
      }
    }
  },
  watch: {
    oidcAccessToken(this: any) {
      axios.defaults.headers.common.Authorization = `Bearer ${this.oidcAccessToken}`;
    },
    isAppIdle(this: any, event) {
      if (this.isAppIdle) {
        this.showIdleTimeOut();
      } else {
        this.clearPostSignInIdleTime();
      }
    },
    now(this: any) {
      if (this.postSignInIdleTime.isSameOrBefore(moment())) {
        this.waitForPostSignInIdleTime = false;
      }
    },
    oidcIsAuthenticated(this: any) {
      if (this.oidcIsAuthenticated) {
        this.currentUserAuthenticated();
      }
    },
    showApplicationDirtyModal(this: any) {
      if (this.showApplicationDirtyModal) {
        const callBackFunction = () => this.$router.push(this.applicationDirtyRouteNavigatedTo);
        this.confirmDiscardChangesOnApplicationDirty(callBackFunction);
      }
    }
  },
  created(this: any) {
    window.addEventListener('beforeunload', (event: any) => this.beforeUnloadApplication(event));
    LocalStorage.on(localStorageKeys.LastSelectedWorkflowQueue, this.manageLastSelectedWorkflowQueue);
    LocalStorage.on(localStorageKeys.IsApplicationLoggedOutOnAnotherTab, this.signOutFromAnotherTab);
    LocalStorage.on(localStorageKeys.IsApplicationDirtyOnAnotherTab, this.setApplicationDirtyOnAnotherTab);
    LocalStorage.on(localStorageKeys.IsAppIdleOnAnotherTab, this.showIdleTimeOut);
    LocalStorage.on(localStorageKeys.IsAppIdleExtended, this.extendSession);
    document.addEventListener('mStoreUpdated', this.onApplicationUpdateAvailable, { once: true });

    navigator.serviceWorker.addEventListener('controllerchange', this.refreshApp);
  },
  mounted(this: any) {
    const vm = this;
    AxiosConfiguration.configure();
    SnotifyConfiguration.configure(vm);
    this.nowIntervalId = setInterval(this.setNowToNow, 1000);
    this.extendSession();
  },
  beforeRouteEnter(this: any) {
    this.keepAliveInclude = this.$route.meta.keepAliveInclude || '';
  },
  beforeDestroy(this: any) {
    clearInterval(this.nowIntervalId);
    clearInterval(this.checkSessionInterval);

    window.removeEventListener('beforeunload', (event: any) => this.beforeUnloadApplication(event));
    LocalStorage.off(localStorageKeys.LastSelectedWorkflowQueue, this.manageLastSelectedWorkflowQueue);
    LocalStorage.off(localStorageKeys.IsApplicationLoggedOutOnAnotherTab, this.signOutFromAnotherTab);
    LocalStorage.off(localStorageKeys.IsApplicationDirtyOnAnotherTab, this.setApplicationDirtyOnAnotherTab);
    LocalStorage.off(localStorageKeys.IsAppIdleOnAnotherTab, this.showIdleTimeOut);
    LocalStorage.off(localStorageKeys.IsAppIdleExtended, this.extendSession);
    navigator.serviceWorker.removeEventListener('controllerchange', this.refreshApp);
  },
  components: {
    BaseLayout,
    ExpiryModal,
    MStorePopup,
    Feedback
  }
});
